import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const LegendOthersToggleContainer = styled(FlexRow)`
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    padding-left: 5px;
    padding-bottom: 8px;
    margin-bottom: 8px;
`;
